import { useIntl } from 'react-intl';
import { Tag, Tooltip, TooltipInteractionEnum } from 'sonata-react-components';

type Props = {
  cartographies: string[];
};

/** Beyond this, the rest are folded into a single "+N" tag. */
const MAX_VISIBLE_CARTOGRAPHIES = 2;

/**
 * Cartographies the campaign's screens fall into, as location tags. Only the first two
 * are listed; the rest are counted in a trailing tag that names them on hover.
 */
export default function UniverseCartographyTags({ cartographies }: Readonly<Props>) {
  const { formatMessage } = useIntl();
  const visible = cartographies.slice(0, MAX_VISIBLE_CARTOGRAPHIES);
  const hidden = cartographies.slice(MAX_VISIBLE_CARTOGRAPHIES);

  if (!visible.length) {
    return null;
  }

  return (
    <div className="metricDetailCards__tags">
      {visible.map(cartography => (
        <Tag
          icon={{ position: 'left', webFont: 'fa-solid fa-location-dot' }}
          id={`universeCartography-${cartography}`}
          key={cartography}
          status="information"
        >
          {cartography}
        </Tag>
      ))}
      {hidden.length > 0 && (
        <Tooltip
          config={{
            component: <span>{hidden.join(', ')}</span>,
            interactions: [TooltipInteractionEnum.hover],
            placement: 'bottom',
            portal: true,
            strategy: 'fixed'
          }}
        >
          <span>
            <Tag id="universeCartography-more">
              {formatMessage(
                { defaultMessage: '+{count}', id: 'doohReport.metricDetailCards.moreCartographies' },
                { count: hidden.length }
              )}
            </Tag>
          </span>
        </Tooltip>
      )}
    </div>
  );
}
